module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tabelaPrecos"
    }
  }, [_c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%",
      "border": "0"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Tipo de certificado\n    ")]), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Validade")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ACS PF DV Alpha")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("1 ano")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ACS PF DV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("1 ano")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ACS PJ OV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("1 ano")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ACS PJ EV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("1 ano")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d149a5f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Precos.vue
// module id = 100
// module chunks = 0